import classNames from 'classnames';
import {
  FlexContainer,
  Txt,
  Button,
  AccountVerificationStatus,
  Icon,
  InfoMessageBlock,
} from 'components';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProperty, usePublicAccount } from 'state';
import { verificationStatusTypes } from 'config/types';
import { TenanciesList } from './components';
import styles from './TenanciesListScreen.module.scss';

/**
 * TenanciesListScreen
 *
 * @return {JSX.Element}
 */
const TenanciesListScreen = ({ className }) => {
  const navigate = useNavigate();
  const property = useProperty();
  const publicAccount = usePublicAccount();
  const [isPastTenanciesOpen, setIsPastTenanciesOpen] = useState(false);
  const { activeTenancies, pastTenancies } = property.tenancies;

  const handleCreateTenancy = () => {
    navigate(`../../tenancy/new`);
  };

  const handleViewTenancy = (tenancyUid) => () => {
    navigate(`../../tenancy/${tenancyUid}`);
  };

  const handleOpenPastTenancies = () => setIsPastTenanciesOpen(true);
  const handleClosePastTenancies = () => setIsPastTenanciesOpen(false);

  return (
    <FlexContainer
      className={classNames(
        styles.TenanciesListScreen,
        className,
        TenanciesListScreen.displayName
      )}
      column
      gap
    >
      {isPastTenanciesOpen ? (
        <FlexContainer column gap>
          <FlexContainer>
            <Button onClick={handleClosePastTenancies}>
              <Icon s name="goback" /> Back
            </Button>
          </FlexContainer>
          {pastTenancies.length ? (
            <TenanciesList
              tenancies={pastTenancies}
              onClick={handleViewTenancy}
            />
          ) : (
            <InfoMessageBlock
              title="No past tenancies"
              description="When a tenancy ends it will appear here."
            />
          )}
        </FlexContainer>
      ) : (
        <FlexContainer column gap>
          {activeTenancies && activeTenancies.length ? (
            <TenanciesList
              tenancies={activeTenancies}
              onClick={handleViewTenancy}
            />
          ) : null}
          {publicAccount.data.verificationStatus ===
          verificationStatusTypes.VERIFIED ? (
            <FlexContainer column gap>
              <Button big onClick={handleCreateTenancy}>
                <FlexContainer spaceBetween alignCenter flex>
                  <Txt xx>Create Tenancy</Txt>
                  <Icon name="plus" />
                </FlexContainer>
              </Button>
            </FlexContainer>
          ) : (
            <AccountVerificationStatus />
          )}
          <FlexContainer column gap>
            <Button big onClick={handleOpenPastTenancies}>
              <FlexContainer spaceBetween alignCenter flex>
                <Txt xx>Past tenancies</Txt>
                <Icon name="documentOutline" />
              </FlexContainer>
            </Button>
          </FlexContainer>
        </FlexContainer>
      )}
    </FlexContainer>
  );
};

TenanciesListScreen.displayName = 'TenanciesListScreen';

export default observer(TenanciesListScreen);
